import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import SubHeader from "../../components/Subheader/Subheader";
import Spinner from "../../components/Tools/spinner";
import CustomBreadcrumbs from "../../components/Tools/Breadcumbs";
import { useNavigate } from "react-router-dom";
import "./ConsolidateDashboard.css";
import { ArrowUpDown } from "lucide-react";
import {
  fetchConsolidateDashboard,
  exportConsolidateDashboard,
} from "../../helper/Api";

const ConsolidateDashboard = () => {
  const { authData, financialYears } = useSelector((state) => state.authData);
  const [expendAll, setExpenddAll] = useState(true);
  const [loading, setLoading] = useState(false);
  const fy_list = financialYears.payload.fy_list;
  const [divisionNumber, setDivisionNumber] = useState(1);
  const fyIdRef = useRef(localStorage.getItem("globalDateId"));
  const [activeCard, setActiveCard] = useState([]);
  const [subheadTables, setSubheadTables] = useState([]);
  const handleSubheadTable = (id) => {
    setSubheadTables((prev) => {
      let updated = [...prev];
      if (updated.includes(id)) {
        updated = updated.filter((item) => item !== id);
      } else {
        updated.push(id);
      }
      return updated;
    });
  };
  const [schemes, setSchemes] = useState([]);
  const navigate = useNavigate();
  const handlePageTrigger = () => {
    fyIdRef.current = localStorage.getItem("globalDateId");
  };
  const [divider, setDivider] = useState(1);
  const mainCardSwitch = (val1, val2, val3, detailObj) => {
    setActiveCard((prev) => {
      let updated = [...prev];
      // Remove val2 and val3 if present
      updated = updated.filter((item) => item !== val2 && item !== val3);
      // Add val1 if not already present
      if (!updated.includes(val1)) {
        updated.unshift(val1); // Add at the beginning
      }
      return updated;
    });
  };

  const fetchConsolidateData = async () => {
    try {
      setLoading(true);
      const response = await fetchConsolidateDashboard({
        financial_year_id: fyIdRef.current,
      });
      if (response.data.status) {
        setSchemes(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching consolidate data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setDivider(divisionNumber);
  }, [divisionNumber]);

  useEffect(() => {
    fetchConsolidateData();
  }, [fyIdRef.current]);

  const calculateExpense = (tierFigures) => {
    return tierFigures?.reduce(
      (total, tier) => total + Number(tier.expenses),
      0
    );
  };

  const calculateSchemeExpense = (scheme) => {
    let expense = 0;
    scheme.subheads.forEach((subhead) => {
      expense += calculateExpense(subhead.tierFigures);
    });
    return expense;
  };

  const downloadFile = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "file.xlsx"); // Suggested filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportConsolidateReport = async () => {
    setLoading(true);
    try {
      const schemes = await exportConsolidateDashboard({
        financial_year_id: fyIdRef.current,
      });
      if (schemes.data.status) {
        setLoading(false);
        downloadFile(schemes.data.url);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div>
          {" "}
          <Spinner />{" "}
        </div>
      )}
      <SubHeader
        fy_list={fy_list}
        setDivisionNumber={setDivisionNumber}
        handlePageTrigger={handlePageTrigger}
      />
      <div className="row" style={{ padding: "10px 16px" }}>
        <div className="col-md-6">
          <h4 style={{ color: "#28326f", margin: 0 }}>Consolidate Dashboard</h4>
          <CustomBreadcrumbs linksArray={[]} title="Consolidate Dashboard" />
        </div>
        <div className="col-md-6">
          <div
            className="m-0 p-0 d-flex gap-2"
            style={{ width: "auto", float: "right" }}
          >
            <button type="button" className="submit_button">
              <span
                className="fs-14px"
                onClick={() => exportConsolidateReport()}
              >
                Export Report
              </span>
            </button>

            <button type="button" className="cancel_button">
              <span
                className="fs-14px"
                onClick={() => setExpenddAll(expendAll ? false : true)}
              >
                {expendAll ? "Close" : "Expand"} All Child
              </span>
            </button>

            <button type="button" className="navigation_button">
              <span className="fs-14px" onClick={() => navigate("/")}>
                Dashboard
              </span>
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        <div
          className="px-3 col-12 d-flex flex-column gap-3 overflow-y-auto overflow-x-hidden"
          style={{ height: "100vh" }}
        >
          {schemes.map((e, index) => (
            <div
              className="bg-white border-Prime-100 my-2 p-0"
              style={{ borderRadius: "8px" }}
            >
              <div
                className="bg-prime-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden"
                style={{ borderRadius: "8px 8px 0 0" }}
              >
                {/* ======================card header================== */}
                <span
                  className="fs-14px white-space-nowrap overflow-x-hidden d-flex justify-content-between align-items-center gap-2 p-0 m-0 w-100"
                  style={{ width: "95%", fontStyle: "italic" }}
                >
                  {/* =======================card header====================== */}
                  <span
                    className="fs-14px white-space-nowrap overflow-x-hidden"
                    style={{ width: "95%", fontStyle: "italic" }}
                  >
                    <span className="fw-500 text-secondary-100">
                      Scheme Id {e.code}-{e.name}
                    </span>
                  </span>
                </span>
              </div>

              <div className="row py-2 px-3">
                <div className="col-md-2"></div>
                <div className="col-md-2">
                  <div className="light-green-div bg-success-20">
                    <span className="fw-500 fs-12px">
                      Prov. Budget FY{" "}
                      {fy_list?.map((val, ind) => {
                        return (
                          Number(val?.id) == Number(fyIdRef.current) &&
                          val?.year
                        );
                      })}{" "}
                      <br />
                      <span className="fs-18px text-success-100">
                        {e.provisional_budget.toLocaleString("en-IN")}
                      </span>
                    </span>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="light-green-div bg-success-20">
                    <span className="fw-500 fs-12px">
                      Released Budget FY{" "}
                      {fy_list?.map((val, ind) => {
                        return (
                          Number(val?.id) == Number(fyIdRef.current) &&
                          val?.year
                        );
                      })}
                    </span>{" "}
                    <br />
                    <span className="fs-18px text-success-100">
                      {e.budget.toLocaleString("en-IN")}
                    </span>
                  </div>
                </div>
                <div className="col-md-2"></div>
                <div className="col-md-2">
                  <div
                    className="light-green-div"
                    style={{ backgroundColor: "#28316f" }}
                  >
                    <span
                      className="fw-500 fs-12px"
                      style={{ color: "#ffffff" }}
                    >
                      Expense Budget FY{" "}
                      {fy_list?.map((val, ind) => {
                        return (
                          Number(val?.id) == Number(fyIdRef.current) &&
                          val?.year
                        );
                      })}
                    </span>{" "}
                    <br />
                    <span className="fs-18px" style={{ color: "#ffffff" }}>
                      {calculateSchemeExpense(e).toLocaleString("en-IN")}
                    </span>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="light-green-div bg-success-100">
                    <span
                      className="fw-500 fs-12px"
                      style={{ color: "#ffffff" }}
                    >
                      Balance FY{" "}
                      {fy_list?.map((val, ind) => {
                        return (
                          Number(val?.id) == Number(fyIdRef.current) &&
                          val?.year
                        );
                      })}{" "}
                      <br />
                      <span className="fs-18px" style={{ color: "#ffffff" }}>
                        {(e.budget - calculateSchemeExpense(e)).toLocaleString(
                          "en-IN"
                        )}
                      </span>
                    </span>
                  </div>
                </div>
              </div>

              <div className="px-2 m-0">
                <div className="border mb-2"></div>
                <div className="pb-2 d-flex justify-content-between text-secondary-50 px-4">
                  <button
                    onClick={() =>
                      mainCardSwitch(
                        `subhead_${e.id}`,
                        `activity_${e.id}`,
                        `subactivity_${e.id}`,
                        {
                          scheme_id: e.id,
                          subhead: true,
                          activity: false,
                          subActivity: false,
                        }
                      )
                    }
                    className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1 rounded-4 ${
                      activeCard.includes(`subhead_${e.id}`)
                        ? "bg-secondary-20"
                        : "bg-white"
                    } `}
                  >
                    {activeCard.includes(`subhead_${e.id}`) ? (
                      <i className="icon-remove_circle_outline"></i>
                    ) : (
                      <i className="icon-add_circle_outline"></i>
                    )}
                    Sub head
                  </button>
                  <button
                    onClick={() =>
                      mainCardSwitch(
                        `activity_${e.id}`,
                        `subhead_${e.id}`,
                        `subactivity_${e.id}`,
                        {
                          scheme_id: e.id,
                          subhead: false,
                          activity: true,
                          subActivity: false,
                        }
                      )
                    }
                    className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4 ${
                      activeCard.includes(`activity_${e.id}`)
                        ? "bg-secondary-20"
                        : "bg-white"
                    } `}
                  >
                    {activeCard.includes(`activity_${e.id}`) ? (
                      <i className="icon-remove_circle_outline"></i>
                    ) : (
                      <i className="icon-add_circle_outline"></i>
                    )}
                    Activity
                  </button>
                  <button
                    onClick={() =>
                      mainCardSwitch(
                        `subactivity_${e.id}`,
                        `activity_${e.id}`,
                        `subhead_${e.id}`,
                        {
                          scheme_id: e.id,
                          subhead: false,
                          activity: false,
                          subActivity: true,
                        }
                      )
                    }
                    className={` ${
                      activeCard.includes(`subactivity_${e.id}`)
                        ? "bg-secondary-20"
                        : "bg-white"
                    } border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4`}
                  >
                    {activeCard.includes(`subactivity_${e.id}`) ? (
                      <i className="icon-remove_circle_outline"></i>
                    ) : (
                      <i className="icon-add_circle_outline"></i>
                    )}
                    Sub-Activity
                  </button>
                </div>
              </div>

              {activeCard.includes(`subhead_${e.id}`) && (
                <>
                  <div className="border mx-2"></div>
                  <div style={{ overflowX: "auto" }} className="w-100 px-2">
                    {e.subheads.map((subhead, subheadIndex) => (
                      <>
                        <div
                          className="bg-success-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden mt-2"
                          style={{ borderRadius: "8px 8px 0 0" }}
                          key={subheadIndex}
                        >
                          <span
                            className="fs-14px white-space-nowrap overflow-x-hidden d-flex justify-content-between align-items-center gap-2 p-0 m-0 w-100"
                            style={{ width: "95%", fontStyle: "italic" }}
                          >
                            <span
                              className="fs-14px white-space-nowrap overflow-x-hidden d-flex justify-content-between align-items-center gap-2 p-0 m-0 w-100"
                              style={{ width: "95%", fontStyle: "italic" }}
                            >
                              <span className="fw-500 text-secondary-100">
                                Scheme Id {subhead.code}-{subhead.name}
                              </span>
                              <span className="d-flex gap-2 p-0 m-0 justify-self-end align-items-center">
                                {subheadTables.includes(
                                  `subhead_${subhead.id}_details`
                                ) ? (
                                  <i
                                    className="icon-remove_circle_outline"
                                    onClick={() =>
                                      handleSubheadTable(
                                        `subhead_${subhead.id}_details`
                                      )
                                    }
                                  ></i>
                                ) : (
                                  <i
                                    className="icon-add_circle_outline"
                                    onClick={() =>
                                      handleSubheadTable(
                                        `subhead_${subhead.id}_details`
                                      )
                                    }
                                  ></i>
                                )}
                              </span>
                            </span>
                          </span>
                        </div>
                        <div
                          className={`row py-2 px-3 ${
                            subheadTables.includes(`subhead_${subhead.id}`)
                              ? ""
                              : "d-none"
                          }`}
                        >
                          <div className="col-md-12">
                            <table className="w-100 subhead-table" border={1}>
                              <thead>
                                <tr>
                                  <th>Tier</th>
                                  <th>
                                    Prov. Budget{" "}
                                    {fy_list?.map((val, ind) => {
                                      return (
                                        Number(val?.id) ==
                                          Number(fyIdRef.current) && val?.year
                                      );
                                    })}
                                  </th>
                                  <th>
                                    Released Budget{" "}
                                    {fy_list?.map((val, ind) => {
                                      return (
                                        Number(val?.id) ==
                                          Number(fyIdRef.current) && val?.year
                                      );
                                    })}
                                  </th>
                                  <th>
                                    Allocation FY{" "}
                                    {fy_list?.map((val, ind) => {
                                      return (
                                        Number(val?.id) ==
                                          Number(fyIdRef.current) && val?.year
                                      );
                                    })}
                                  </th>
                                  <th>
                                    Expense FY{" "}
                                    {fy_list?.map((val, ind) => {
                                      return (
                                        Number(val?.id) ==
                                          Number(fyIdRef.current) && val?.year
                                      );
                                    })}
                                  </th>
                                  <th>
                                    Balance FY{" "}
                                    {fy_list?.map((val, ind) => {
                                      return (
                                        Number(val?.id) ==
                                          Number(fyIdRef.current) && val?.year
                                      );
                                    })}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {subhead.tierFigures.map(
                                  (tierFig, tierIndex) => (
                                    <tr key={tierIndex}>
                                      <td>{tierFig?.department_level}</td>
                                      <td>
                                        {Number(
                                          tierFig?.provisional_budget
                                        )?.toLocaleString("en-IN")}
                                      </td>
                                      <td>
                                        {Number(
                                          tierFig?.budget
                                        )?.toLocaleString("en-IN")}
                                      </td>
                                      <td>
                                        {Number(
                                          tierFig?.allocated_budget
                                        )?.toLocaleString("en-IN")}
                                      </td>
                                      <td>
                                        {Number(
                                          tierFig?.expenses
                                        )?.toLocaleString("en-IN")}
                                      </td>
                                      <td>
                                        {(
                                          Number(tierFig?.budget) -
                                          (Number(tierFig?.allocated_budget) +
                                            Number(tierFig?.expenses))
                                        )?.toLocaleString("en-IN")}
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div
                          style={{ backgroundColor: "#ecececff" }}
                          className="mb-2 p-0"
                        >
                          <div className="row py-2 px-3">
                            <div className="col-md-2">
                              {subheadTables.includes(
                                `subhead_${subhead.id}`
                              ) ? (
                                <div
                                  className="up-down-arrow-active"
                                  onClick={() =>
                                    handleSubheadTable(`subhead_${subhead.id}`)
                                  }
                                >
                                  <ArrowUpDown size={24} />
                                </div>
                              ) : (
                                <div
                                  className="up-down-arrow"
                                  onClick={() =>
                                    handleSubheadTable(`subhead_${subhead.id}`)
                                  }
                                >
                                  <ArrowUpDown size={24} />
                                </div>
                              )}
                            </div>
                            <div className="col-md-2">
                              <div className="light-green-div bg-success-20">
                                <span className="fw-500 fs-12px">
                                  Prov. Budget FY{" "}
                                  {fy_list?.map((val, ind) => {
                                    return (
                                      Number(val?.id) ==
                                        Number(fyIdRef.current) && val?.year
                                    );
                                  })}{" "}
                                  <br />
                                  <span className="fs-18px text-success-100">
                                    {Number(
                                      subhead.provisional_budget
                                    ).toLocaleString("en-IN")}
                                  </span>
                                </span>
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="light-green-div bg-success-20">
                                <span className="fw-500 fs-12px">
                                  Released Budget FY{" "}
                                  {fy_list?.map((val, ind) => {
                                    return (
                                      Number(val?.id) ==
                                        Number(fyIdRef.current) && val?.year
                                    );
                                  })}
                                </span>{" "}
                                <br />
                                <span className="fs-18px text-success-100">
                                  {subhead.budget.toLocaleString("en-IN")}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-2"></div>
                            <div className="col-md-2">
                              <div
                                className="light-green-div"
                                style={{ backgroundColor: "#28316f" }}
                              >
                                <span
                                  className="fw-500 fs-12px"
                                  style={{ color: "#ffffff" }}
                                >
                                  Expense Budget FY{" "}
                                  {fy_list?.map((val, ind) => {
                                    return (
                                      Number(val?.id) ==
                                        Number(fyIdRef.current) && val?.year
                                    );
                                  })}
                                </span>{" "}
                                <br />
                                <span
                                  className="fs-18px"
                                  style={{ color: "#ffffff" }}
                                >
                                  {calculateExpense(
                                    subhead.tierFigures
                                  )?.toLocaleString("en-IN")}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="light-green-div bg-success-100">
                                <span
                                  className="fw-500 fs-12px"
                                  style={{ color: "#ffffff" }}
                                >
                                  Balance FY{" "}
                                  {fy_list?.map((val, ind) => {
                                    return (
                                      Number(val?.id) ==
                                        Number(fyIdRef.current) && val?.year
                                    );
                                  })}{" "}
                                  <br />
                                  <span
                                    className="fs-18px"
                                    style={{ color: "#ffffff" }}
                                  >
                                    {(
                                      subhead.budget -
                                      calculateExpense(subhead.tierFigures)
                                    ).toLocaleString("en-IN")}
                                  </span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className={`row py-2 px-3 ${
                            subheadTables.includes(
                              `subhead_${subhead.id}_details`
                            )
                              ? ""
                              : "d-none"
                          }`}
                        >
                          <div className="col-md-12">
                            <table className="w-100 account-table">
                              <thead>
                                <tr>
                                  <th>T2 Name</th>
                                  <th>T2 Account</th>
                                  <th>T3 Account</th>
                                  <th>T4 Account</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td></td>
                                  <td style={{ padding: 0, margin: 0 }}>
                                    <table>
                                      <tr>
                                        <td>Account Name</td>
                                        <td>Account No.</td>
                                        <td>Allocation By T1</td>
                                        <td>Expense</td>
                                      </tr>
                                    </table>
                                  </td>
                                  <td>
                                    <table
                                      style={{ backgroundColor: "#ccd2f8" }}
                                    >
                                      <tr>
                                        <td>Account Name</td>
                                        <td>Account No.</td>
                                        <td>Allocation By T2</td>
                                        <td>Expense</td>
                                      </tr>
                                    </table>
                                  </td>
                                  <td>
                                    <table>
                                      <tr>
                                        <td>Account Name</td>
                                        <td>Account No.</td>
                                        <td>Allocation By T3</td>
                                        <td>Expense</td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                                {subhead?.departmentTierFigures?.map(
                                  (deptTier, deptIndex) => (
                                    <tr
                                      key={deptIndex}
                                      style={{ border: "1px solid #ccc" }}
                                    >
                                      <td>{deptTier?.name}</td>
                                      <td
                                        style={{ padding: 0, margin: 0 }}
                                        colSpan={3}
                                      >
                                        <table className="w-100">
                                          <tr style={{ padding: 0, margin: 0 }}>
                                            <td style={{ width: "33.33%" }}>
                                              <table className="w-100">
                                                <tbody>
                                                  <tr>
                                                    <td style={{ width: "25%" }}>
                                                      <span className="fs-20px">
                                                        <i
                                                          onClick={() =>
                                                            handleSubheadTable(
                                                              `t2_${e.id}_${subhead.id}_${deptTier.id}`
                                                            )
                                                          }
                                                          className={` ${
                                                            subheadTables.includes(
                                                              `t2_${e.id}_${subhead.id}_${deptTier.id}`
                                                            ) || expendAll
                                                              ? "icon-arrow_drop_down"
                                                              : "icon-arrow_right"
                                                          }`}
                                                        ></i>
                                                      </span>
                                                      {deptTier?.account_name}
                                                    </td>
                                                    <td style={{ width: "25%" }}>
                                                      {deptTier?.account_no}
                                                    </td>
                                                    <td style={{ width: "25%" }}>
                                                      {Number(
                                                        deptTier?.sanctioned
                                                      ).toLocaleString("en-IN")}
                                                    </td>
                                                    <td style={{ width: "25%" }}>
                                                      {Number(
                                                        deptTier?.expense
                                                      ).toLocaleString("en-IN")}
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </td>
                                            <td colSpan={2}>
                                              {deptTier.t3Departments.map(
                                                (t3Dept, t3Index) => (
                                                  <table
                                                    key={t3Index}
                                                    className={`w-100 apply_radius ${
                                                      subheadTables.includes(
                                                        `t2_${e.id}_${subhead.id}_${deptTier.id}`
                                                      ) || expendAll
                                                        ? ""
                                                        : "d-none"
                                                    }`}
                                                    style={{
                                                      marginBottom: "8px",
                                                    }}
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          style={{
                                                            width: "12.5%",
                                                            backgroundColor:
                                                              "#ccd2f8",
                                                          }}
                                                        >
                                                          <span className="fs-20px">
                                                            <i
                                                              onClick={() =>
                                                                handleSubheadTable(
                                                                  `t2_${e.id}_${subhead.id}_${deptTier.id}_${t3Dept.id}`
                                                                )
                                                              }
                                                              className={` ${
                                                                subheadTables.includes(
                                                                  `t2_${e.id}_${subhead.id}_${deptTier.id}_${t3Dept.id}`
                                                                ) || expendAll
                                                                  ? "icon-arrow_drop_down"
                                                                  : "icon-arrow_right"
                                                              }`}
                                                            ></i>
                                                          </span>
                                                          {t3Dept?.account_name}
                                                        </td>
                                                        <td
                                                          style={{
                                                            width: "12.5%",
                                                            backgroundColor:
                                                              "#ccd2f8",
                                                          }}
                                                        >
                                                          {t3Dept?.account_no}
                                                        </td>
                                                        <td
                                                          style={{
                                                            width: "12.5%",
                                                            backgroundColor:
                                                              "#ccd2f8",
                                                          }}
                                                        >
                                                          {Number(
                                                            t3Dept?.sanctioned
                                                          )?.toLocaleString(
                                                            "en-IN"
                                                          )}
                                                        </td>
                                                        <td
                                                          className="td_radius"
                                                          style={{
                                                            width: "12.5%",
                                                            backgroundColor:
                                                              "#ccd2f8",
                                                          }}
                                                        >
                                                          {Number(
                                                            t3Dept?.expense
                                                          )?.toLocaleString(
                                                            "en-IN"
                                                          )}
                                                        </td>
                                                        <td
                                                          colSpan={4}
                                                          style={{ width: "50%" }}
                                                        >
                                                          {t3Dept.t4Departments.map(
                                                            (t4Dept, t4Index) => (
                                                              <table
                                                                key={t4Index}
                                                                className={`w-100 ${
                                                                  subheadTables.includes(
                                                                    `t2_${e.id}_${subhead.id}_${deptTier.id}_${t3Dept.id}`
                                                                  ) || expendAll
                                                                    ? ""
                                                                    : "d-none"
                                                                }`}
                                                              >
                                                                <tbody>
                                                                  <tr>
                                                                    <td>
                                                                      {
                                                                        t4Dept?.account_name
                                                                      }
                                                                    </td>
                                                                    <td>
                                                                      {
                                                                        t4Dept?.account_no
                                                                      }
                                                                    </td>
                                                                    <td>
                                                                      {Number(
                                                                        t4Dept?.sanctioned
                                                                      )?.toLocaleString(
                                                                        "en-IN"
                                                                      )}
                                                                    </td>
                                                                    <td>
                                                                      {Number(
                                                                        t4Dept?.expense
                                                                      )?.toLocaleString(
                                                                        "en-IN"
                                                                      )}
                                                                    </td>
                                                                  </tr>
                                                                </tbody>
                                                                {t4Index === t3Dept.t4Departments.length - 1 && (
                                                                  <tfoot>
                                                                    <tr style={{ backgroundColor: "#f0f0f0", fontWeight: "600" }}>
                                                                      <td colSpan={2}>Total T4</td>
                                                                      <td>
                                                                        {t3Dept.t4Departments.reduce((sum, dept) => sum + Number(dept?.sanctioned || 0), 0).toLocaleString("en-IN")}
                                                                      </td>
                                                                      <td>
                                                                        {t3Dept.t4Departments.reduce((sum, dept) => sum + Number(dept?.expense || 0), 0).toLocaleString("en-IN")}
                                                                      </td>
                                                                    </tr>
                                                                  </tfoot>
                                                                )}
                                                              </table>
                                                            )
                                                          )}
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                    {t3Index === deptTier.t3Departments.length - 1 && (
                                                      <tfoot>
                                                        <tr>
                                                          <td style={{ backgroundColor: "#e0e0e0", fontWeight: "600" }}>Total T3</td>
                                                          <td style={{ backgroundColor: "#e0e0e0", fontWeight: "600" }}></td>
                                                          <td style={{ backgroundColor: "#e0e0e0", fontWeight: "600" }}>
                                                            {deptTier.t3Departments.reduce((sum, dept) => sum + Number(dept?.sanctioned || 0), 0).toLocaleString("en-IN")}
                                                          </td>
                                                          <td style={{ backgroundColor: "#e0e0e0", fontWeight: "600" }}>
                                                            {deptTier.t3Departments.reduce((sum, dept) => sum + Number(dept?.expense || 0), 0).toLocaleString("en-IN")}
                                                          </td>
                                                          <td></td>
                                                        </tr>
                                                      </tfoot>
                                                    )}
                                                  </table>
                                                )
                                              )}
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ConsolidateDashboard;
